<template>
  <div>
    <!-- <pre>{{ data_text }}</pre> -->
    <!-- <pre>{{ get_value }}</pre> -->
    <vs-card class="cardRadi">
      <div slot="header">
        <h3>Data Export</h3>
      </div>
      <!-- <vs-row
        ><vs-spacer />
        <vs-button
          color="success"
          type="filled"
          class="btnSub"
          target
          :href="{ url: 'https://thaiyamaha.shinee.com/index.php' }"
          >รายงานทส.</vs-button
        ></vs-row
      > -->

      <vs-row vs-align="flex-start" vs-type="flex" class="p-3" vs-justify="center" vs-w="12">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
          <vs-select class="selectExample mt-2 container-fluid" label="Duration" v-model="select_duration">
            <vs-select-item :key="index" :value="item.value" :text="item.text"
              v-for="(item, index) in options_duration" />
          </vs-select>
        </vs-col>
        <vs-col v-if="[1].includes(select_duration)" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2"
          vs-sm="4" vs-xs="12">
          <vs-select class="selectExample mt-2 container-fluid" label="Week" v-model="select_week">
            <vs-select-item :key="index" :value="item" :text="item.text" v-for="(item, index) in options_week" />
          </vs-select>
        </vs-col>
        <vs-col v-if="[2, 1].includes(select_duration)" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2"
          vs-sm="4" vs-xs="12">
          <vs-select class="selectExample mt-2 container-fluid" label="Month" v-model="select_month">
            <vs-select-item :key="index" :value="item" :text="item.text" v-for="(item, index) in options_month" />
          </vs-select>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
          <vs-select class="selectExample mt-2 container-fluid" label="Year" v-model="select_year">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in options_year" />
          </vs-select>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
          <vs-button @click="
            showPlan(
              select_duration,
              select_year,
              select_month.value,
              select_week.value
            )
            " color="success" class="btnSub mt-4 mb-2" type="filled">Submit</vs-button>
        </vs-col>
      </vs-row>
    </vs-card>
    <!-- v-if="active" -->
    <vs-card v-if="active" class="cardRadi">
      <!-- <div>{{ select_plan }} {{ select_plan }}</div> -->
      <!-- <pre>{{items[0]}}</pre> -->
      <allReport v-if="items[0] !== []" :select_plan="select_plan" :select_duration="select_duration" :items="items"
        :select_year="exp_year" :data_text="data_text" :total_water_toilet="total_water_toilet"
        :total_water_treat="total_water_treat" :total_electricity="total_electricity" :avg_water_toilet="avg_water_toilet"
        :avg_water_treat="avg_water_treat" :avg_electricity="avg_electricity" />
    </vs-card>
  </div>
</template>

<script>
import planA from "./report_plan/plastic_plant.vue";
import planB from "./report_plan/aluminium_plan.vue";
import planC from "./report_plan/daf_plant.vue";
import planD from "./report_plan/center_plant.vue";
import planE from "./report_plan/as_plan.vue";
import planF from "./report_plan/mbr_plant.vue";
import planG from "./report_plan/recycle_plant.vue";
import planH from "./report_plan/ro_plant.vue";
import allReport from "./report_plan/report.vue";
export default {
  components: {
    allReport,
    planA,
    planB,
    planC,
    planD,
    planE,
    planF,
    planG,
    planH,
  },
  data: () => ({
    active: false,
    get_value: [],
    select_plan: "",
    select_duration: "",
    show_plan: "",
    options_plan: [
      { text: "Plastic Painting WWTP Plant", value: 1 },
      { text: "Aluminium Painting WWTP Plant", value: 2 },
      { text: "DAF Plant", value: 3 },
      { text: "Center Plant", value: 4 },
      { text: "AS Plant", value: 5 },
      { text: "MBR Plant", value: 6 },
      { text: "Recycle Plant", value: 7 },
      { text: "RO  Plant", value: 8 },
    ],
    options_week: [
      { text: "Week 1", value: "01" },
      { text: "Week 2", value: "08" },
      { text: "Week 3", value: "15" },
      { text: "Week 4", value: "22" },
      { text: "Week 5", value: "29" },
    ],
    options_duration: [
      // { text: "1 day", value: 1 },
      { text: "Week", value: 1 },
      { text: "Month", value: 2 },
      { text: "Year", value: 3 },
    ],
    options_month: [
      // { text: "1 day", value: 1 },
      { text: "January", value: "01" },
      { text: "February", value: "02" },
      { text: "March", value: "03" },
      { text: "April", value: "04" },
      { text: "May", value: "05" },
      { text: "June", value: "06" },
      { text: "July", value: "07" },
      { text: "August", value: "08" },
      { text: "September", value: "09" },
      { text: "October", value: "10" },
      { text: "November", value: "11" },
      { text: "December", value: "12" },
    ],
    select_month: { value: "01" },
    select_week: { value: "01" },
    select_year: null,
    get_month: null,
    get_week: null,
    get_year: null,
    options_year: [
      // { text: "1 day", value: 1 },
      // { text: "2021", value: 2021 },
      // { text: "2020", value: 2020 },
      // { text: "2019", value: 2019 },
      // { text: "2018", value: 2018 },
      // { text: "2017", value: 2017 },
    ],
    items: [],
    items_year: [
      {
        age: 2040,
        first_name: "MAR",
        last_name: "Macdonald",
        water_toilet: 2522,
        water_treat: 6587,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 2001,
        first_name: "APR",
        last_name: "Shaw",
        water_toilet: 2929,
        water_treat: 7485,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 2309,
        first_name: "MAY",
        last_name: "Wilson",
        water_toilet: 3235,
        water_treat: 7959,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1040,
        first_name: "JUN",
        last_name: "MacDonald",
        water_toilet: 2325,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1129,
        first_name: "JUL",
        last_name: "Dunlap",
        water_toilet: 1714,
        water_treat: 7485,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 3329,
        first_name: "AUG",
        last_name: "Dunlap",
        water_toilet: 2017,
        water_treat: 5803,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1129,
        first_name: "SEP",
        last_name: "Dunlap",
        water_toilet: 2694,
        water_treat: 6243,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1129,
        first_name: "OCT",
        last_name: "Dunlap",
        water_toilet: 2292,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1129,
        first_name: "NOV",
        last_name: "Dunlap",
        water_toilet: 3259,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1129,
        first_name: "DEC",
        last_name: "Dunlap",
        water_toilet: 2522,
        water_treat: 6038,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
    ],
    items_week: [
      {
        age: 2040,
        first_name: "Sunday",
        last_name: "Macdonald",
        water_toilet: 2522,
        water_treat: 6587,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 2001,
        first_name: "Monday",
        last_name: "Shaw",
        water_toilet: 2929,
        water_treat: 7485,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 2309,
        first_name: "Tuesday",
        last_name: "Wilson",
        water_toilet: 3235,
        water_treat: 7959,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1040,
        first_name: "Wednesday",
        last_name: "MacDonald",
        water_toilet: 2325,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1040,
        first_name: "Thursday",
        last_name: "MacDonald",
        water_toilet: 2325,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1040,
        first_name: "Friday",
        last_name: "MacDonald",
        water_toilet: 2325,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1040,
        first_name: "Saturday",
        last_name: "MacDonald",
        water_toilet: 2325,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
    ],
    items_month: [
      {
        age: 2040,
        first_name: "Week 1",
        last_name: "Macdonald",
        water_toilet: 2522,
        water_treat: 6587,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 2001,
        first_name: "Week 2",
        last_name: "Shaw",
        water_toilet: 2929,
        water_treat: 7485,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 2309,
        first_name: "Week 3",
        last_name: "Wilson",
        water_toilet: 3235,
        water_treat: 7959,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
      {
        age: 1040,
        first_name: "Week 4",
        last_name: "MacDonald",
        water_toilet: 2325,
        water_treat: 2522,
        electricity: "",
        sludge: "-",
        cost_of_electricity: 74643.28,
        cost_of_sludge: 74643.28,
        total_cost: "",
        cost_of_chem1: 3.94,
        cost_of_chem2: 3.94,
      },
    ],
    total_water_toilet: null,
    total_water_treat: null,
    total_electricity: null,
    avg_water_toilet: null,
    avg_water_treat: null,
    avg_electricity: null,
    exp_year: null,
    value_cal: {
      powerData: 0,
      waterData: 0,
    },
    data_text: {
      type: 0,
      month: "",
      week: "",
      year: "",
    },
  }),
  methods: {
    errorFunc() {
      this.$vs.loading.close();
      this.$vs.notify({
        title: "Fetch Data Error",
        text: "Can't find any data",
        color: "danger",
        position: "top-center",
      });
      this.active = false;
    },
    async showPlan(item_plan, item_year, item_month, item_week) {
      console.log(item_year);
      this.$vs.loading();
      this.show_plan = item_plan;
      let arr_water_toilet = [];
      let arr_water_treat = [];
      let arr_electricity = [];
      this.total_water_toilet = null;
      this.total_water_treat = null;
      this.total_electricity = null;
      this.avg_water_toilet = null;
      this.avg_water_treat = null;
      this.avg_electricity = null;
      this.exp_year = null;
      this.items = [];
      this.get_month = "";
      this.get_week = "";
      this.get_year = "";

      switch (this.select_duration) {
        case 1:
          // this.items = this.items_week;
          this.exp_year = this.select_year;
          this.get_value = await this.$API
            .get(`yamaha/report/weekly/${item_year}-${item_month}-${item_week}`)
            .catch((error) => {
              this.errorFunc();
            });
          if (this.get_value.length == 0) {
            this.errorFunc();
          }
          this.data_text.type = 1;
          this.data_text.year = item_year;
          this.data_text.week = this.select_week.text;
          this.data_text.month = this.select_month.text;
          this.items = this.get_value.data;
          this.$vs.loading.close();
          break;
        case 2:
          // this.items = this.items_month;
          this.exp_year = this.select_year;
          this.get_value = await this.$API
            .get(`yamaha/report/monthly/${item_year}-${item_month}-01`)
            .catch((error) => {
              this.errorFunc();
            });
          if (this.get_value.length == 0) {
            this.errorFunc();
          }
          this.items = this.get_value.data;
          this.data_text.type = 2;
          this.data_text.year = item_year;
          this.data_text.week = "";
          this.data_text.month = this.select_month.text;
          this.select_week = "";
          this.$vs.loading.close();
          break;
        case 3:
          // this.items = this.items_year;
          this.exp_year = this.select_year;
          this.get_value = await this.$API
            .get(`yamaha/report/yearly/${item_year}-01-01`)
            .catch((error) => {
              this.errorFunc();
            });
          if (this.get_value.length == 0) {
            this.errorFunc();
          }
          this.items = this.get_value.data;
          this.data_text.type = 3;
          this.data_text.year = item_year;
          this.data_text.week = "";
          this.data_text.month = "";
          this.$vs.loading.close();
          break;
        default:
          console.log("Try looking up for a hint.");
          this.$vs.loading.close();
      }
      this.active = true;
    },
    caltotal(item) { },
    generateArrayOfYears() {
      var max = new Date().getFullYear();
      var min = max - 10;
      var years = [];

      for (var i = max; i >= min; i--) {
        years.push(i);
      }
      return years;
    },
  },
  mounted() {
    let arr_water_toilet = [];
    let arr_water_treat = [];
    let arr_electricity = [];
    this.items.forEach((item) => {
      item.electricity = item.water_toilet + item.water_treat;
      this.total_water_toilet += item.water_toilet;
      this.total_water_treat += item.water_treat;
      this.total_electricity += item.electricity;

      arr_water_toilet.push(item.water_toilet);
      arr_water_treat.push(item.water_treat);
      arr_electricity.push(item.electricity);
      this.avg_water_toilet = (
        this.total_water_toilet / arr_water_toilet.length
      ).toFixed(2);
      this.avg_water_treat = (
        this.total_water_treat / arr_water_treat.length
      ).toFixed(2);
      this.avg_electricity = (
        this.total_electricity / arr_electricity.length
      ).toFixed(2);
    });
    this.options_year = this.generateArrayOfYears();
  },
};
</script>

<style scoped>
.btnSub {
  width: 100px;
  border-radius: 20px;
}

.cardRadi {
  border-radius: 20px;
}
</style>